import * as types from "@/store/types";

const state = {
  modalStep: 1,
  isModalOpen: false
};

const getters = {
  [types.mobile.getters.IS_MODAL_OPEN]: state => {
    return state.isModalOpen;
  },
  [types.mobile.getters.MODAL_STEP]: state => {
    return state.modalStep;
  }
};

const mutations = {
  [types.mobile.mutations.MUTATE_STEP]: (state, payload) => {
    state.modalStep = payload;
  },
  [types.mobile.mutations.MUTATE_MODAL]: (state, payload) => {
    state.isModalOpen = payload;
  }
};

const actions = {
  [types.mobile.actions.SET_STEP]: ({ commit }, payload) => {
    commit(types.mobile.mutations.MUTATE_STEP, payload);
  },
  [types.mobile.actions.SET_MODAL]: ({ commit }, payload) => {
    commit(types.mobile.mutations.MUTATE_MODAL, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
